import { createFileRoute } from "@tanstack/react-router";
import { RiskFraudPage } from "@/components/admin/risk-fraud/RiskFraudPage";

export const Route = createFileRoute("/pulse-ops-x7k2/risk-fraud")({
  component: RiskFraudPage,
});
